import { ButtonColor, ButtonVariant, Icon, IconButton } from '../../../components';
import { ComponentSize } from '../../../types';

interface ExplorerItemEndIconProps {
  icon: Icon;
  onClick: () => void;
  active?: boolean;
}

const ExplorerItemEndIcon = ({ icon, onClick, active }: ExplorerItemEndIconProps) => {
  return (
    <IconButton
      active={active}
      icon={icon}
      color={ButtonColor.NEUTRAL}
      size={ComponentSize.X_SMALL}
      variant={ButtonVariant.GHOST}
      onClick={onClick}
    />
  );
};

export default ExplorerItemEndIcon;
